module.exports = __webpack_public_path__ + "static/media/gautam.bbcb6469.png";